import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllARUniEntryRequestStatuses } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/arUniEntryRequestStatuses";
const arUniEntryRequestStatusesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(arUniEntryRequestStatusesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(arUniEntryRequestStatusesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(arUniEntryRequestStatusesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const arUniEntryRequestStatusesThunk = createAsyncThunk(
  `${sliceName}/arUniEntryRequestStatusesThunk`,
  async () => {
    const response = await getAllARUniEntryRequestStatuses()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.arUniEntryRequestStatuses);
    },
  },
);

export default arUniEntryRequestStatusesSlice.reducer;
